import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { baseUrl } from "../../utils/APi";
import { Link, useNavigate } from "react-router-dom";
import { removeFromCart, removeAllFromCart } from "../../store/cart/cartSlice";

import { failed, sucess } from "../../component/toast/Toast";
import { applyCoupon, setCheckout } from "../../store/checkout/checkAction";
import { getAddress } from "../../store/auth/authAction";
import bg from "../../assets/pexels-tara-winstead-8386713.jpg";
import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/3.jpg";
import img4 from "../../assets/main/4.jpg";
import img5 from "../../assets/main/5.jpg";
import img6 from "../../assets/main/6.jpg";

const Activites = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Portfolio</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <Link class="section-16px-regular font-weight-500" to={"/"}>
                    Home
                  </Link>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">
                    Portfolio
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-portfolio">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="portfolio-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="portfolio-post">
                  <img src={img1} alt="images" />
                </div>
                <div class="portfolio-content">
                  <Link to={"/SingleActivity"} class="mark-item"></Link>
                  <div class="title-item link-style-5">
                    <Link
                      to={"/SingleActivity"}
                      class="section-24px-montserrat"
                    >
                      Web Development
                    </Link>
                    <p class="margin-top-20">
                      There are many variations of passages of Lorem Ipsum
                      available
                    </p>
                  </div>
                </div>
              </div>
              <div class="portfolio-box wow fadeInUp" data-wow-delay="0.4s">
                <div class="portfolio-post">
                  <img src={img2} alt="images" />
                </div>
                <div class="portfolio-content">
                  <Link to={"/SingleActivity"} class="mark-item"></Link>
                  <div class="title-item link-style-5">
                    <Link
                      to={"/SingleActivity"}
                      class="section-24px-montserrat"
                    >
                      Web Development
                    </Link>
                    <p class="margin-top-20">
                      There are many variations of passages of Lorem Ipsum
                      available
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="portfolio-box active">
                <div class="portfolio-post">
                  <img src={img3} alt="images" />
                </div>
                <div class="portfolio-content">
                  <Link to={"/SingleActivity"} class="mark-item"></Link>
                  <div class="title-item link-style-5">
                    <Link
                      to={"/SingleActivity"}
                      class="section-24px-montserrat"
                    >
                      Web Development
                    </Link>
                    <p class="margin-top-20">
                      There are many variations of passages of Lorem Ipsum
                      available
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="portfolio-box">
                <div class="portfolio-post">
                  <img src={img4} alt="images" />
                </div>
                <div class="portfolio-content">
                  <Link to={"/SingleActivity"} class="mark-item"></Link>
                  <div class="title-item link-style-5">
                    <Link
                      to={"/SingleActivity"}
                      class="section-24px-montserrat"
                    >
                      Web Development
                    </Link>
                    <p class="margin-top-20">
                      There are many variations of passages of Lorem Ipsum
                      available
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="portfolio-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="portfolio-post">
                  <img src={img5} alt="images" />
                </div>
                <div class="portfolio-content">
                  <Link to={"/SingleActivity"} class="mark-item"></Link>
                  <div class="title-item link-style-5">
                    <Link
                      to={"/SingleActivity"}
                      class="section-24px-montserrat"
                    >
                      Web Development
                    </Link>
                    <p class="margin-top-20">
                      There are many variations of passages of Lorem Ipsum
                      available
                    </p>
                  </div>
                </div>
              </div>
              <div class="portfolio-box wow fadeInUp" data-wow-delay="0.4s">
                <div class="portfolio-post">
                  <img src={img6} alt="images" />
                </div>
                <div class="portfolio-content">
                  <Link to={"/SingleActivity"} class="mark-item"></Link>
                  <div class="title-item link-style-5">
                    <Link
                      to={"/SingleActivity"}
                      class="section-24px-montserrat"
                    >
                      Web Development
                    </Link>
                    <p class="margin-top-20">
                      There are many variations of passages of Lorem Ipsum
                      available
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Activites;
